/**
 * 학원 목록·상세 쿼리 키와 페이지 크기.
 * 서버 프리페치(page.tsx)와 클라이언트 훅(academy.query.ts)이 같은 값을 써야
 * 하이드레이션이 맞물린다. 어긋나면 곧바로 다시 요청해 서버가 실은 본문이 버려진다.
 */
import { QUERY_KEYS } from '@/services/base-api';
import { GetAcademyListParams } from '@/services/types/academy.type';

export const ACADEMY_LIST_LIMIT = 10;

export function academyListQueryKey(params?: GetAcademyListParams) {
  return [QUERY_KEYS.ACADEMY, QUERY_KEYS.LIST, params] as const;
}

export function academyDetailQueryKey(id: number) {
  return [QUERY_KEYS.ACADEMY, QUERY_KEYS.DETAIL, id] as const;
}

export function academyRegionQueryKey() {
  return [QUERY_KEYS.ACADEMY, QUERY_KEYS.REGION, QUERY_KEYS.LIST] as const;
}
